import axios from "axios";

const store = {
  state: {},

  getters: {},

  mutations: {},

  actions: {
    amountPaymentAction() {
      return new Promise((resolve, reject) => {
        axios
          .post(`/payment/amount-charge`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    amountReceivableAction() {
      return new Promise((resolve, reject) => {
        axios
          .post(`/vehicule/amount-receivable`)
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    countVehiculeVerified() {
      return new Promise((resolve, reject) => {
        axios
          .get(`/vehicule/count-vehicule-verified`)
          .then((res) => {
            resolve(res.data.count);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};

export default store;
